var React = require('react');

function TrustpilotStarInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M25.4737 8.40775H15.7462L12.7415 0L9.72751 8.40775L0 8.39923L7.87778 13.6008L4.86376 22L12.7415 16.807L20.6099 22L17.6053 13.6008L25.4737 8.40775Z","fill":"#00B67A","key":0}),React.createElement("path",{"opacity":"0.4","d":"M18.2803 15.5024L17.6042 13.6008L12.7405 16.807L18.2803 15.5024Z","fill":"#005128","key":1})]);
}

TrustpilotStarInline.defaultProps = {"width":"26","height":"22","viewBox":"0 0 26 22","fill":"none"};

module.exports = TrustpilotStarInline;

TrustpilotStarInline.default = TrustpilotStarInline;
